import React from "react";
import { Link } from "react-router-dom";
import style from "./index.module.scss";
import classNames from "classnames";

export default function StuNavBar() {
    return (
        <div className={style.root}>
            <div className={style.links}>
                <Link
                    replace
                    className={classNames(style.link, {
                        [style.current]: true
                    })}
                    to="resource">
                    课件
                </Link>
            </div>
        </div>
    );
}
